<template>
  <Dialog :visible="true" modal :style="{ width: '32rem' }" :breakpoints="{ '640px': '95vw' }" header="تعديل الهيدر" @update:visible="$emit('close')">
    <div class="form-field">
      <label class="field-label">اسم الموقع (يظهر في شريط الجوال)</label>
      <input type="text" class="form-control" v-model="form.site_title" placeholder="طارق عبدالغني عبدالباري" />
    </div>

    <div class="form-field mt-2">
      <label class="field-label">الشعار (اللوجو)</label>
      <input type="file" class="form-control" accept="image/*" @change="onFile" />
      <img v-if="logoPreview" :src="logoPreview" class="hb-preview-thumb mt-2" alt="" />
    </div>

    <div class="form-field mt-2 hb-visibility">
      <label class="field-label">الحالة</label>
      <InputSwitch v-model="form.is_active" />
    </div>

    <template #footer>
      <button class="btn-cancel" @click="$emit('close')">إلغاء</button>
      <button class="ds-btn ds-btn--primary" :disabled="store.saving" @click="save">
        <i class="pi pi-check"></i> {{ store.saving ? 'جارٍ الحفظ...' : 'حفظ' }}
      </button>
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import InputSwitch from 'primevue/inputswitch';
import Swal from 'sweetalert2';
import { useHomepageSectionStore } from '@/stores/useHomepageSectionStore.js';

export default {
  name: 'HeaderEditor',
  components: { Dialog, InputSwitch },
  props: { section: { type: Object, required: true } },
  emits: ['close', 'saved'],
  data() {
    return {
      form: {
        site_title: this.section.settings?.site_title || '',
        is_active: !!this.section.is_active,
      },
      logoFile: null,
      logoPreview: this.section.settings?.logo || null,
    };
  },
  computed: {
    store() { return useHomepageSectionStore(); },
  },
  methods: {
    onFile(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.logoFile = file;
      this.logoPreview = URL.createObjectURL(file);
    },
    async save() {
      try {
        const fd = new FormData();
        fd.append('settings[site_title]', this.form.site_title);
        fd.append('is_active', this.form.is_active ? 1 : 0);
        if (this.logoFile) fd.append('logo_file', this.logoFile);
        await this.store.updateSection(this.section.id, fd);
        Swal.fire({ icon: 'success', title: 'تم الحفظ', timer: 1400, showConfirmButton: false });
        this.$emit('saved');
      } catch (e) {
        Swal.fire({ icon: 'error', title: e?.response?.data?.message || 'حدث خطأ', timer: 2500, showConfirmButton: false });
      }
    },
  },
};
</script>

<style scoped>
.hb-preview-thumb { max-width: 120px; max-height: 60px; object-fit: contain; border-radius: 8px; border: 1px solid var(--surface-border, #e5e7eb); }
.hb-visibility { display: flex; align-items: center; justify-content: space-between; }
</style>
